import { Box, Tab, Tabs } from "@mui/material"
import { AdminEnumType } from "../../../enums/adminEnum"
import { TABLE_HEADER_BACKGROUND_COLOR } from "../../../constants/colors"
import { useTranslation } from "react-i18next"

interface Props {
    value: AdminEnumType
    onChange: (newValue: AdminEnumType) => void
    isSuperAdmin: boolean
    currentPage: (newValue: number) => void
}

const TabPanelComponents = ({ value, onChange, isSuperAdmin, currentPage }: Props) => {
    const { t } = useTranslation('global');
    return (
        <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={(e: any, newValue: AdminEnumType) => {
                        onChange(newValue);
                        currentPage(1)
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                >
                    {isSuperAdmin && (
                        <Tab label={t("Super Admin")} value={AdminEnumType.SUPER_ADMIN} />
                    )}

                    <Tab label={t("Admin")} value={AdminEnumType.ADMIN} />
                </Tabs>
            </Box>
        </Box>
    );
}
export default TabPanelComponents